import { getAPIHost } from '../getAPIHost/getAPIHost';

export const getLogHost = () => {
  return getAPIHost();
};
